import amanSajidImage from "@/assets/aman-sajid.png";

export const SpfDkimDmarcFounderQuote = () => {
  return (
    <div className="bg-card rounded-2xl border border-border p-6 sm:p-8">
      <div className="flex items-start gap-4">
        <img
          src={amanSajidImage}
          alt="Aman Sajid"
          className="w-14 h-14 rounded-full object-cover border-2 border-primary/20"
        />
        <div>
          <blockquote className="text-foreground italic leading-relaxed">
            "I've audited hundreds of email setups, and authentication issues are the #1 cause of deliverability problems. Most people set it up once and forget it — but a single misconfigured record can tank your inbox rate overnight."
          </blockquote>
          <div className="mt-4">
            <p className="font-semibold text-foreground">Aman Sajid</p>
            <p className="text-sm text-muted-foreground">Founder, IT Dukes</p>
          </div>
        </div>
      </div>
    </div>
  );
};
